import React from 'react'
import {Switch,Route} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent";
const ReportBankConciliation =({match})=>(
    <Switch>
          <Route  path={`${match.url}/CopyBankConciliation`} component={asyncComponent(()=>import( './CopyBankConciliation/index'))} />
    </Switch>
)
export default ReportBankConciliation;